"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-1b1d1a4c"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "app-content" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", {
    id: "container",
    class: "container"
}, null, -1));
const index_vue_1 = __importDefault(require("./RectNode/index.vue"));
const index_vue_2 = __importDefault(require("./SquareNode/index.vue"));
const index_vue_3 = __importDefault(require("./Label/index.vue"));
const index_vue_4 = __importDefault(require("./PartingLine/index.vue"));
const x6_1 = require("@antv/x6");
const x6_vue_shape_1 = require("@antv/x6-vue-shape");
const vue_3 = require("vue");
const NodeList_1 = require("./NodeList");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    emits: ['getClickNodeData'],
    setup(__props, { emit: __emit }) {
        (0, x6_vue_shape_1.register)({
            shape: 'rectNode',
            width: 150,
            height: 50,
            component: index_vue_1.default,
            ports: {
                groups: {
                    top: {
                        position: 'top',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                    right: {
                        position: 'right',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                    bottom: {
                        position: 'bottom',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                    left: {
                        position: 'left',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                },
            },
        });
        (0, x6_vue_shape_1.register)({
            shape: 'squareNode',
            width: 100,
            height: 100,
            component: index_vue_2.default,
            ports: {
                groups: {
                    top: {
                        position: 'top',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                    right: {
                        position: 'right',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                    bottom: {
                        position: 'bottom',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                    left: {
                        position: 'left',
                        attrs: {
                            circle: {
                                r: 0,
                            },
                        },
                    },
                },
            },
        });
        (0, x6_vue_shape_1.register)({
            shape: 'label',
            width: 100,
            height: 100,
            component: index_vue_3.default,
        });
        (0, x6_vue_shape_1.register)({
            shape: 'partingLine',
            width: 1500,
            height: 1,
            component: index_vue_4.default,
        });
        //箭头样式配置项
        const edgeAttr = {
            line: {
                sourceMarker: null,
                targetMarker: {
                    name: 'block',
                    stroke: '#2BBDFF',
                    fill: '#2BBDFF',
                },
                stroke: {
                    type: 'linearGradient',
                    stops: [
                        { offset: '0%', color: '#A9F5FF' },
                        { offset: '100%', color: '#2BBDFF' },
                    ],
                },
                strokeWidth: 2,
                strokeDasharray: 4,
                style: {
                    animation: 'ant-line 60s infinite linear',
                },
            },
        };
        //连接桩配置项
        const getPortList = (index, portName) => {
            return [
                {
                    id: portName + '_' + ((index + 1) * 4 - 3),
                    group: 'top',
                },
                {
                    id: portName + '_' + ((index + 1) * 4 - 2),
                    group: 'right',
                },
                {
                    id: portName + '_' + ((index + 1) * 4 - 1),
                    group: 'bottom',
                },
                {
                    id: portName + '_' + (index + 1) * 4,
                    group: 'left',
                },
            ];
        };
        const TeleportContainer = (0, x6_vue_shape_1.getTeleport)();
        (0, vue_3.onMounted)(() => {
            const NODESTARTX = 180; //node节点起始X值
            const NODEINTERVAL = 230; //采购流程和生产制造流程的node节点间隔X值
            const SELLNODEINTERVAL = 197; //销售流程的node节点间隔X值
            const OPERATIONNODEINTERVAL = 173; //运营运维流程的node节点间隔X值
            const graph = new x6_1.Graph({
                container: document.getElementById('container'),
                background: {
                    color: '#FFFFFF',
                },
                autoResize: true,
            });
            NodeList_1.labelList.forEach((item) => {
                graph.addNode({
                    shape: 'label',
                    x: 0,
                    y: item.y,
                    data: {
                        label: item.label,
                        x: 0,
                        y: item.y,
                    }
                });
            });
            NodeList_1.partingLine.forEach((item) => {
                graph.addNode({
                    shape: 'partingLine',
                    x: 0,
                    y: item,
                    draggable: false,
                });
            });
            const purchaseNodeList = NodeList_1.purchase.map((item, index) => {
                return graph.addNode({
                    shape: 'rectNode',
                    x: NODESTARTX + NODEINTERVAL * index,
                    y: 60,
                    data: {
                        label: item.label,
                        imgUrl: require("../../../assets/img/blueRect@2x.png"),
                        usable: item.usable,
                        x: NODESTARTX + NODEINTERVAL * index,
                        y: 60,
                    },
                    ports: {
                        items: getPortList(index, "purchase")
                    },
                });
            });
            for (let i = 0; i < purchaseNodeList.length - 1; i++) {
                const source = { cell: purchaseNodeList[i], port: 'purchase_' + ((i + 1) * 4 - 2) };
                const target = { cell: purchaseNodeList[i + 1], port: 'purchase_' + (i + 2) * 4 };
                graph.addEdge({
                    source,
                    target,
                    attrs: edgeAttr,
                });
            }
            const productNodeList = NodeList_1.product.map((item, index) => {
                let x = NODESTARTX + NODEINTERVAL * index;
                let y = 220;
                const xEnd = NODESTARTX + NODEINTERVAL * 6;
                if (index >= 7) {
                    x = xEnd - (index - 7) * NODEINTERVAL;
                    y = 300;
                }
                return graph.addNode({
                    shape: 'rectNode',
                    x,
                    y,
                    data: {
                        label: item.label,
                        imgUrl: require("../../../assets/img/greenRect@2x.png"),
                        usable: item.usable,
                        x,
                        y,
                    },
                    ports: {
                        items: getPortList(index, "product")
                    },
                });
            });
            for (let i = 0; i < productNodeList.length - 1; i++) {
                let source = { cell: productNodeList[i], port: 'product_' + ((i + 1) * 4 - 2) };
                let target = { cell: productNodeList[i + 1], port: 'product_' + (i + 2) * 4 };
                if (i == 6) {
                    source.port = 'product_23';
                    target.port = 'product_25';
                }
                if (i > 6) {
                    source.port = 'product_' + (i + 1) * 4;
                    target.port = 'product_' + ((i + 2) * 4 - 2);
                }
                graph.addEdge({
                    source,
                    target,
                    attrs: edgeAttr,
                });
            }
            const marketNodeList = NodeList_1.market.map((item, index) => {
                return graph.addNode({
                    shape: (item === null || item === void 0 ? void 0 : item.shape) ? 'squareNode' : 'rectNode',
                    x: (item === null || item === void 0 ? void 0 : item.shape) ? NODESTARTX + SELLNODEINTERVAL * index + 25 : NODESTARTX + SELLNODEINTERVAL * index,
                    y: (item === null || item === void 0 ? void 0 : item.shape) ? 425 : 450,
                    data: {
                        label: item.label,
                        imgUrl: (item === null || item === void 0 ? void 0 : item.shape) ? require("../../../assets/img/orangeSquare@2x.png") : require("../../../assets/img/orangeRect@2x.png"),
                        usable: item.usable,
                        x: (item === null || item === void 0 ? void 0 : item.shape) ? NODESTARTX + SELLNODEINTERVAL * index + 25 : NODESTARTX + SELLNODEINTERVAL * index,
                        y: (item === null || item === void 0 ? void 0 : item.shape) ? 425 : 450,
                    },
                    ports: {
                        items: getPortList(index, "market")
                    },
                });
            });
            for (let i = 0; i < marketNodeList.length - 1; i++) {
                const source = { cell: marketNodeList[i], port: 'market_' + ((i + 1) * 4 - 2) };
                const target = { cell: marketNodeList[i + 1], port: 'market_' + (i + 2) * 4 };
                graph.addEdge({
                    source,
                    target,
                    attrs: edgeAttr,
                });
            }
            const operationNodeList = NodeList_1.operation.map((item, index) => {
                return graph.addNode({
                    shape: (item === null || item === void 0 ? void 0 : item.shape) ? 'squareNode' : 'rectNode',
                    x: (item === null || item === void 0 ? void 0 : item.shape) ? NODESTARTX + OPERATIONNODEINTERVAL * index + 25 : NODESTARTX + OPERATIONNODEINTERVAL * index,
                    y: (item === null || item === void 0 ? void 0 : item.shape) ? 625 : 650,
                    data: {
                        label: item.label,
                        imgUrl: (item === null || item === void 0 ? void 0 : item.shape) ? require("../../../assets/img/violetSquare@2x.png") : require("../../../assets/img/violetRect@2x.png"),
                        usable: item.usable,
                        x: (item === null || item === void 0 ? void 0 : item.shape) ? NODESTARTX + OPERATIONNODEINTERVAL * index + 25 : NODESTARTX + OPERATIONNODEINTERVAL * index,
                        y: (item === null || item === void 0 ? void 0 : item.shape) ? 625 : 650,
                    },
                    ports: {
                        items: getPortList(index, "operation")
                    },
                });
            });
            for (let i = 0; i < operationNodeList.length - 1; i++) {
                const source = { cell: operationNodeList[i], port: 'operation_' + ((i + 1) * 4 - 2) };
                const target = { cell: operationNodeList[i + 1], port: 'operation_' + (i + 2) * 4 };
                graph.addEdge({
                    source,
                    target,
                    attrs: edgeAttr,
                });
            }
            graph.addEdge({
                source: { cell: productNodeList[1] },
                target: { cell: purchaseNodeList[0] },
                attrs: edgeAttr,
                vertices: [
                    { x: 460, y: 161 },
                    { x: 255, y: 161 },
                ],
            }).prop('source', {
                x: 460, y: 220
            });
            graph.addEdge({
                source: { cell: purchaseNodeList[6], port: 'purchase_26' },
                target: { cell: productNodeList[1] },
                attrs: edgeAttr,
                vertices: [
                    { x: 1750, y: 85 },
                    { x: 1750, y: 161 },
                    { x: 510, y: 161 },
                ],
            }).prop('target', {
                x: 510, y: 220
            });
            graph.addEdge({
                source: { cell: productNodeList[10] },
                target: { cell: marketNodeList[3] },
                attrs: edgeAttr,
                vertices: [
                    { x: 945, y: 381 },
                    { x: 845, y: 381 },
                ],
            });
            graph.addEdge({
                source: { cell: marketNodeList[2] },
                target: { cell: productNodeList[0] },
                attrs: edgeAttr,
                label: {
                    attrs: {
                        text: {
                            text: 'M T O / E T O',
                            fill: '#FFFFFF'
                        },
                        rect: {
                            fill: 'transparent'
                        }
                    },
                    position: {
                        offset: {
                            x: 40,
                            y: -20
                        }
                    }
                },
                vertices: [
                    { x: 649, y: 381 },
                    { x: 255, y: 381 },
                ],
            });
            graph.addEdge({
                source: { cell: marketNodeList[7], port: 'market_30' },
                target: { cell: operationNodeList[0] },
                attrs: edgeAttr,
                vertices: [
                    { x: 1750, y: 475 },
                    { x: 1750, y: 581 },
                    { x: 255, y: 581 },
                ],
            });
            graph.zoomToFit({
                maxScale: 1, padding: {
                    top: 20,
                    bottom: 20,
                }
            });
            graph.on('node:click', ({ cell }) => {
                const nodeData = cell.getData();
                if (nodeData.usable) {
                    emit('getClickNodeData', nodeData);
                }
            });
            graph.on('node:moved', (node) => {
                const time = 200;
                const { cell } = node;
                const data = cell.getData();
                const chaX = (data.x - node.x) / time;
                const chaY = (data.y - node.y) / time;
                for (let i = 1; i <= time; i++) {
                    setTimeout(() => {
                        cell.prop('position', { x: node.x + chaX * i, y: node.y + chaY * i });
                    }, 1);
                }
            });
        });
        const emit = __emit;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (0, vue_2.createVNode)((0, vue_2.unref)(TeleportContainer))
            ]));
        };
    }
});
